<template lang="pug">
  .wallet
    v-container.white.pa-0(style="max-width:600px")
      credit-alert.mt-4(:credit="creditBalance" :showTitle="false")
      div.ml-4.mt-8.h6.basic700--text {{ $t('credit_history') }}
      credit-history.mt-4(ref="creditHistory" :company="company")
</template>

<script>
import { mapGetters } from 'vuex'
import CreditHistory from '@/components/settings/bills/CreditHistory.vue'
import CreditAlert from '@/components/yezzabook/dialogs/CreditAlert.vue'

export default {
  name: 'Wallet',
  components: { CreditHistory, CreditAlert },
  data () {
    return {}
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    creditBalance() {
      return this.company.prepaid_credits
    },
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>